import { SolariMark } from './SolariMark';
import { TRACKED_REG } from '../lib/flightTrack';

// The app's masthead: the airplane's registration in Sora, with a "Powered by
// SOLARI" chip under it. Replaces the AJM wordmark at the top of every pilot's
// app (Casey, 9/26/26). The demo build reads N123AB here through TRACKED_REG.
export function TailLockup({ compact = false }: { compact?: boolean }) {
  return (
    <div className={compact ? 'flex items-center gap-2.5' : ''}>
      <div
        className={`font-bold leading-none tracking-[-0.02em] text-navy-900 ${compact ? 'text-[22px]' : 'text-[30px]'}`}
        // Sora's caps sit ~2px above the centre of a line-height-1 box at 22px (measured:
        // cap centre 9.1px in a 22px box). In the phone header everything else centres
        // on the row, so drop the glyphs to meet them.
        style={{ fontFamily: "Sora, 'SF Pro Display', -apple-system, sans-serif", transform: compact ? 'translateY(2px)' : undefined }}
      >
        {TRACKED_REG}
      </div>
      {/* Phone header: the tail is caps-only with line-height 1, so its optical centre
            sits above the box centre. Lift the chip to meet it (Casey 9/26: "even"). */}
        <div className={compact ? 'flex' : 'mt-1 flex'}>
        <PoweredBySolari compact={compact} />
      </div>
    </div>
  );
}

// "Powered by SOLARI" — a navy chip with the split-flap wordmark in white. The
// seam through the letters is the identity's one detail (see Solari's Logo.tsx);
// the mark flips in on load exactly like the product wordmark. Sizes are fixed in px so
// the chip is identical on every screen: 20px tall in the sidebar, 18px in the
// phone header. Casey 9/26/26: option 3D, "smaller and more precise sized".
export function PoweredBySolari({ compact = false }: { compact?: boolean }) {
  const h = compact ? 18 : 20;
  return (
    <span
      className="inline-flex items-center rounded-full bg-navy-900 text-white"
      style={{ height: h, padding: compact ? '0 8px 0 7px' : '0 9px 0 8px', gap: compact ? 5 : 6 }}
    >
      <span
        className="font-semibold uppercase text-sky-300"
        style={{ fontSize: compact ? 8 : 8.5, lineHeight: 1, letterSpacing: '0.12em', paddingTop: 0.5 }}
      >
        Powered by
      </span>
      <SolariMark
        variant="white"
        ground="night"
        style={{ fontSize: compact ? 10 : 10.5, paddingTop: 1 }}
      />
    </span>
  );
}
